var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09998 12.5003C5.09998 11.9112 5.57754 11.4336 6.16664 11.4336C6.75575 11.4336 7.23331 11.9112 7.23331 12.5003C7.23331 13.0894 6.75575 13.5669 6.16664 13.5669C5.57754 13.5669 5.09998 13.0894 5.09998 12.5003ZM10.4333 12.5003C10.4333 11.9112 10.9109 11.4336 11.5 11.4336C12.0891 11.4336 12.5666 11.9112 12.5666 12.5003C12.5666 13.0894 12.0891 13.5669 11.5 13.5669C10.9109 13.5669 10.4333 13.0894 10.4333 12.5003ZM15.7666 12.5003C15.7666 11.9112 16.2442 11.4336 16.8333 11.4336C17.4224 11.4336 17.9 11.9112 17.9 12.5003C17.9 13.0894 17.4224 13.5669 16.8333 13.5669C16.2442 13.5669 15.7666 13.0894 15.7666 12.5003Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableOptions);
export default __webpack_public_path__ + "static/media/tableOptions.5ecc1414947a4057c65f0ce0b712c3c2.svg";
export { ForwardRef as ReactComponent };